import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { ProjectOutput } from 'core/http/root';
import { Observable } from 'rxjs';

export interface DevCourierOutput {
  id: string;
  code: string;
  name: string;
  unloaderClass: string;
  enabledProjects: ProjectOutput[];
  trackPatterns: string[];
}

export interface DevCourierInput {
  name: string;
  unloaderClass: string;
  enabledProjects: string[];
  code: string;
}

@Injectable()
export class CourierService {
  constructor(private http: HttpClient) {}

  getAllCouriers(): Observable<DevCourierOutput[]> {
    return this.http.get<DevCourierOutput[]>(apiUrl(`/dev/couriers`));
  }

  createCourier(input: DevCourierInput): Observable<DevCourierOutput> {
    return this.http.post<DevCourierOutput>(apiUrl('/dev/courier'), input);
  }

  updateCourier(courierId: string, input: DevCourierInput): Observable<DevCourierOutput> {
    return this.http.put<DevCourierOutput>(apiUrl(`/dev/courier/${courierId}`), input);
  }

  getIntegrationClasses(): Observable<string[]> {
    return this.http.get<string[]>(apiUrl(`/dev/courier-integrations`));
  }

  getCourier(courierId: string): Observable<DevCourierOutput> {
    return this.http.get<DevCourierOutput>(apiUrl(`/dev/courier/${courierId}`));
  }
}
